import { render } from "./PromptsList.vue?vue&type=template&id=3d65dc7a&scoped=true"
import script from "./PromptsList.vue?vue&type=script&lang=js"
export * from "./PromptsList.vue?vue&type=script&lang=js"

import "./PromptsList.vue?vue&type=style&index=0&id=3d65dc7a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d65dc7a"]])

export default __exports__